export default __webpack_public_path__ + "static/media/yael-pedhatzur.f916aa3e.png";